export default __webpack_public_path__ + "static/media/digital-marketing.ffb45b53.png";